import styled from "styled-components";
import { TitleH4 } from "../checkout/styled";

export const Title4 = styled(TitleH4)``;

export const Paragraph = styled.p`
  line-height: 20px;
  color: rgba(104, 104, 104, 1);
`;
